import { createTheme } from '@mui/material/styles';
import { gridClasses } from '@mui/x-data-grid';

const pinkTheme = (mode: 'light' | 'dark') =>
  createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
    palette: {
      mode,
      primary: {
        main: '#874B6D',
        light: '#eaddff',
        dark: '#533746',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#625b71',
        light: '#e8def8',
        dark: '#1d192b',
        contrastText: '#ffffff',
      },
      error: {
        main: '#b3261e',
        light: '#f9dedc',
        dark: '#410e0b',
        contrastText: '#ffffff',
      },
      background: {
        default: mode === 'light' ? '#FFF8F8' : '#121212',
        paper: mode === 'light' ? '#ffffff' : '#1d1d1d',
      },
      text: {
        primary: '#211A1D',
        secondary: '#49454f',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          contained: {
            width: 'auto',
            textTransform: 'none',
            borderRadius: '30px',
            fontWeight: '400',
            padding: '10px',
          },
          outlined: {
            width: 'auto',
            textTransform: 'none',
            borderRadius: '30px',
            fontWeight: '400',
            padding: '10px',
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: mode === 'light' ? '#F9EAEF' : '#121212',
            color: mode === 'light' ? '#211A1D' : '#ffffff',
          },
        },
      },
    },
  });

// Extend DataGrid styles
pinkTheme.components = {
  ...pinkTheme.components,
  MuiDataGrid: {
    styleOverrides: {
      columnHeaders: {
        backgroundColor: '#EDDFE3',
      },
    },
  },
};

export default pinkTheme;